import { useLocation } from 'react-router-dom';
import { Link as RouterLink } from 'react-router-dom';
import { NavContentBlueprint } from '@backstage/plugin-app-react';
import type { NavContentNavItem } from '@backstage/plugin-app-react';
import { Nav } from '@internal/kern-ux';

/** An entry is active when the path matches exactly or lies below it. */
const isCurrent = (pathname: string, href: string) =>
  href === '/' ? pathname === '/' : pathname.startsWith(href);

const KernNavItem = (item: NavContentNavItem) => {
  const { pathname } = useLocation();
  return (
    <Nav.Item
      as={RouterLink}
      to={item.href}
      icon={item.icon}
      current={isCurrent(pathname, item.href)}
    >
      {item.title}
    </Nav.Item>
  );
};

/**
 * Main navigation in the KERN look.
 *
 * Replaces the Backstage sidebar entirely. Search, notifications and settings live in the
 * application header (see ../layout), so they are taken out here.
 */
export const SidebarContent = NavContentBlueprint.make({
  params: {
    component: ({ navItems }) => {
      const nav = navItems.withComponent(KernNavItem);

      nav.take('page:search');
      nav.take('page:notifications');
      nav.take('page:user-settings');

      // The legal pages live in the footer, not in the main navigation.
      nav.take('page:app/barrierefreiheit');
      nav.take('page:app/impressum');
      nav.take('page:app/datenschutz');

      return (
        <Nav>
          <Nav.Section>Bereiche</Nav.Section>
          <Nav.List>
            {nav.take('page:home')}
            {nav.take('page:catalog')}
            {nav.take('page:scaffolder')}
            {nav.take('page:techdocs')}
            {nav.take('page:visionflow/anonymisierung')}
            {nav.rest({ sortBy: 'title' })}
          </Nav.List>
        </Nav>
      );
    },
  },
});
